import { Checkbox, Form, Input } from 'antd';
import ContractTypeSelector from '@/components/organisms/contract/ContractTypeSelector';
import { useMemo } from 'react';
import * as React from 'react';
import ContractWriteFormTemplate from '@/components/template/contract/ContractWriteFormTemplate';
import ContractUserType, { key, title } from '@/components/organisms/contract/ContractUserType';
import ContractDriverLicenseTypeSelector from '@/components/organisms/contract/ContractDriverLicenseTypeSelector';

type ContractUserFormProps = {
  userType: ContractUserType;
  extra?: React.ReactNode;
  isEqualChecked?: boolean;
  onChangeEqual?: (checked: boolean) => void;
};

const ContractUserForm = ({ userType, extra, isEqualChecked, onChangeEqual }: ContractUserFormProps) => {
  const isInputDisabled = useMemo(() => {
    return userType === ContractUserType.PRIMARY && isEqualChecked;
  }, [userType, isEqualChecked]);

  const selector = useMemo(() => {
    switch (userType) {
      case ContractUserType.CONTRACTOR:
        return (
          <Form.Item name={[key(userType), 'userType']} label="구분">
            <ContractTypeSelector />
          </Form.Item>
        );
      case ContractUserType.PRIMARY:
      case ContractUserType.SECONDARY:
        return (
          <>
            <Form.Item name={[key(userType), 'driverLicenseType']} label="운전면허 종류">
              <ContractDriverLicenseTypeSelector />
            </Form.Item>
            <Form.Item
              name={[key(userType), 'driverLicenseNo']}
              label="운전면허번호"
              rules={[{ required: true, message: '운전면허번호를 입력해주세요' }]}
            >
              <Input />
            </Form.Item>
          </>
        );
      default:
        return null;
    }
  }, [userType]);

  const optional = useMemo(() => {
    switch (userType) {
      case ContractUserType.CONTRACTOR:
        return (
          <Checkbox
            onChange={({ target }) => {
              if (onChangeEqual) {
                onChangeEqual(target.checked);
              }
            }}
          >
            운전자와 임차인 정보가 같습니다.
          </Checkbox>
        );
      default:
        return null;
    }
  }, [onChangeEqual, userType]);

  return (
    <ContractWriteFormTemplate title={title(userType)} name={key(userType)} extra={userType === ContractUserType.PRIMARY && extra}>
      {selector}
      <Form.Item name={[key(userType), 'name']} label="이름" rules={[{ required: !isInputDisabled, message: '이름을 입력해주세요' }]}>
        <Input disabled={isInputDisabled} />
      </Form.Item>
      <Form.Item name={[key(userType), 'contact']} label="연락처" rules={[{ required: !isInputDisabled, message: '연락처를 입력해주세요' }]}>
        <Input disabled={isInputDisabled} />
      </Form.Item>
      <Form.Item name={[key(userType), 'registrationNo']} label="생년월일" rules={[{ required: !isInputDisabled, message: '정보를 입력해주세요' }]}>
        <Input disabled={isInputDisabled} />
      </Form.Item>
      <Form.Item name={[key(userType), 'addr1']} label="주소" rules={[{ required: !isInputDisabled, message: '주소를 입력해주세요' }]}>
        <Input disabled={isInputDisabled} />
      </Form.Item>
      <Form.Item name={[key(userType), 'addr2']} label="상세주소">
        <Input disabled={isInputDisabled} />
      </Form.Item>
      <Form.Item name={[key(userType), 'postcode']} label="우편번호" rules={[{ required: !isInputDisabled, message: '우편번호를 입력해주세요' }]}>
        <Input disabled={isInputDisabled} />
      </Form.Item>
      {optional}
    </ContractWriteFormTemplate>
  );
};

ContractUserForm.defaultProps = {
  extra: <></>,
  isEqualChecked: false,
  onChangeEqual: () => null,
};

export default ContractUserForm;
